import { render, staticRenderFns } from "./UserInfoProtect.vue?vue&type=template&id=5b0b7a72&scoped=true"
import script from "./UserInfoProtect.vue?vue&type=script&lang=js"
export * from "./UserInfoProtect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0b7a72",
  null
  
)

export default component.exports